import moment from "moment";

/**
 * Given input data, generates a request parameters object for performing a request to the DynamicTimeSlotResource
 *
 * @param {string|int} practitionerId
 * @param {string|int} workplaceId
 * @param {string|Date} startDate
 * @param {string|Date} endDate
 * @param {boolean} [futureOnly]
 * @returns {Object}
 */
export default function (practitionerId, workplaceId, startDate, endDate, futureOnly=true) {
    var startDateTime = moment(startDate),
        endDateTime = moment(endDate);
    return {
        practitioner_id: practitionerId,
        workplace_id: workplaceId,
        start_datetime: startDateTime.format("YYYY-MM-DD HH:mm:ss.SSS"),
        start_date: startDateTime.format("YYYY-MM-DD"),
        start_time: startDateTime.format("HH:mm:ss.SSS"),
        end_datetime: endDateTime.format("YYYY-MM-DD HH:mm:ss.SSS"),
        end_date: endDateTime.format("YYYY-MM-DD"),
        end_time: endDateTime.format("HH:mm:ss.SSS"),
        future_only: futureOnly
    };
};
